import script from "./InstallPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallPrompt.vue?vue&type=script&setup=true&lang=js"

import "./InstallPrompt.vue?vue&type=style&index=0&id=fa056162&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa056162"]])

export default __exports__